export default {
  'nav.home': 'Startseite',
  'nav.spreadsheet': 'Spreadsheet',
  'nav.categories': 'Kategorien',
  'nav.guides': 'Ratgeber',
  'nav.reviews': 'Bewertungen',
  'nav.shipping': 'Versand',
  'nav.safety': 'Sicherheit',
  'nav.shoppingGuide': 'Einkaufsratgeber',

  // Page headers
  'page.spreadsheet.title': 'AllChinaBuy Spreadsheet Kategorien',
  'page.spreadsheet.subtitle': 'Durchsuche alle Kategorien im AllChinaBuy Spreadsheet und springe direkt zu den gewünschten Produkten.',
  'page.guides.title': 'AllChinaBuy Anleitungen und Artikel',
  'page.guides.subtitle': 'Originelle, praktische Anleitungen zu QC, Versand, Sicherheit und Kauftipps.',
  'page.reviews.title': 'AllChinaBuy Bewertungen und unabhängige Recherche',
  'page.reviews.subtitle': 'Ehrliche, unabhängige Einblicke, um AllChinaBuy vor der Bestellung zu bewerten.',
  'page.safety.title': 'AllChinaBuy Sicherheitsleitfaden',
  'page.safety.subtitle': 'Eine praktische Checkliste zum Prüfen von Informationen und Reduzieren gängiger Kaufrisiken.',

  'hero.badge': 'Unabhängige Ressource · Regelmäßig geprüft',
  'hero.title': 'AllChinaBuy Spreadsheet — Finden, vergleichen und clever einkaufen',
  'hero.subtitle': 'Entdecke organisierte Produktfunde, Kategorie-Ratgeber, QC-Informationen, Versandressourcen und praktische Kauftipps an einem Ort. Ob du neu bei AllChinaBuy bist oder erfahrener Käufer — diese Ressource hilft dir, Produkte zu recherchieren, Optionen zu vergleichen und fundiertere Entscheidungen vor der Bestellung zu treffen.',
  'hero.searchPlaceholder': 'Produkte, Kategorien, Verkäufer oder Ratgeber suchen…',
  'hero.ctaPrimary': 'Spreadsheet entdecken',
  'hero.ctaSecondary': 'Jetzt kaufen',
  'hero.trustLine': 'Unabhängige Ressource · Nützliche Ratgeber · Regelmäßig geprüft',

  'category.title': 'Nach Kategorie stöbern',
  'category.subtitle': 'Springe direkt zu der Kategorie, die du auf der Hauptwebsite brauchst.',
  'category.dropdownLabel': 'Kategorie wählen',
  'category.dropdownPlaceholder': 'Kategorie auswählen…',
  'category.viewAll': 'Alle Kategorien ansehen',
  'category.note': 'Informationen können sich ändern. Prüfe Produkt- und Verkäuferdetails vor der Bestellung.',

  'cat.shoes': 'Schuhe',
  'cat.hoodies': 'Hoodies / Sweatshirts',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jacken',
  'cat.pants': 'Hosen / Shorts',
  'cat.headwear': 'Kopfbedeckung',
  'cat.sets': 'Sets',
  'cat.underwear': 'Unterwäsche',
  'cat.jersey': 'Trikots',
  'cat.accessories': 'Accessoires',
  'cat.bags': 'Taschen',
  'cat.belts': 'Gürtel',
  'cat.perfumes': 'Parfums',
  'cat.other': 'Sonstiges',

  'about.title': 'Alles, was du für die AllChinaBuy-Recherche brauchst',
  'about.subtitle': 'Ein klarer, ehrlicher Ausgangspunkt, um das AllChinaBuy Spreadsheet zu verstehen.',
  'about.paragraph1': 'Das AllChinaBuy Spreadsheet ist eine von der Community organisierte Sammlung von Produktlinks, Kategorien und Kaufressourcen. Es bündelt Funde aus Schuhen, Kleidung, Taschen, Accessoires und mehr, damit du das durchstöbern kannst, was du brauchst — ohne verstreute Links zu suchen.',
  'about.paragraph2': 'Diese Website ist eine unabhängige Informationsressource. Sie ist nicht die offizielle AllChinaBuy-Website und nicht mit ihr verbunden. Wir erklären, wie das Spreadsheet funktioniert, wie du Produkte bewertest und wie du Versand und QC vor der Bestellung recherchierst.',

  'feature.spreadsheet.title': 'AllChinaBuy Spreadsheet',
  'feature.spreadsheet.desc': 'Durchstöbere organisierte Produktfunde und Kategorie-Ressourcen.',
  'feature.qc.title': 'QC-Ratgeber',
  'feature.qc.desc': 'Lerne, Produktfotos, Qualitätsdetails und Größen zu verstehen.',
  'feature.shipping.title': 'Versand',
  'feature.shipping.desc': 'Verstehe Versandoptionen, Kosten, Gewicht und häufige Fehler.',
  'feature.reviews.title': 'Bewertungen',
  'feature.reviews.desc': 'Lies unabhängige Recherchen und praktische AllChinaBuy-Bewertungen.',
  'feature.safety.title': 'Sicherheit',
  'feature.safety.desc': 'Lerne, Informationen zu prüfen und typische Kaufrisiken zu senken.',
  'feature.comparisons.title': 'Vergleiche',
  'feature.comparisons.desc': 'Vergleiche AllChinaBuy mit anderen beliebten Kaufplattformen.',

  'beginner.title': 'Neu bei AllChinaBuy?',
  'beginner.desc': 'Starte mit unserem Einsteiger-Ratgeber, um zu lernen, wie das Spreadsheet funktioniert, wie du Produkte bewertest, QC-Fotos verstehst und den Versand vor der Bestellung recherchierst.',
  'beginner.cta': 'Einsteiger-Ratgeber lesen',

  'research.title': 'Recherchiere vor dem Kauf',
  'research.desc': 'Produktlinks, Preise, Verkäufer und Versandbedingungen können sich ändern. Nutze diese Website als Recherche-Ressource und prüfe aktuelle Informationen vor dem Kauf.',
  'research.cta': 'Sicherheits-Ratgeber lesen',

  'guides.title': 'Neueste Ratgeber und Artikel',
  'guides.subtitle': 'Originelle, praktische Ratgeber für eine cleverere Recherche.',
  'guides.readMore': 'Artikel lesen',
  'guides.article1.title': 'So nutzt du das AllChinaBuy Spreadsheet: kompletter Einsteiger-Guide',
  'guides.article1.desc': 'Erfahre, was das AllChinaBuy Spreadsheet ist, wie es aufgebaut ist und wie du Kategorien durchstöberst und Produkte vor der Bestellung prüfst.',
  'guides.article1.meta': 'Ein einsteigerfreundlicher Guide zum AllChinaBuy Spreadsheet über Funktionsweise, Kategorie-Navigation, Produktrecherche und Sicherheitstipps.',

  'faq.title': 'Häufig gestellte Fragen',
  'faq.subtitle': 'Schnelle Antworten auf häufige Fragen zum AllChinaBuy Spreadsheet.',
  'faq.q1': 'Ist dies die offizielle AllChinaBuy-Website?',
  'faq.a1': 'Nein. Dies ist eine unabhängige Informationsressource über das AllChinaBuy Spreadsheet. Wir sind nicht mit AllChinaBuy verbunden.',
  'faq.q2': 'Was ist das AllChinaBuy Spreadsheet?',
  'faq.a2': 'Es ist eine von der Community organisierte Sammlung von Produktlinks und Kategorien. Sie hilft Käufern, Schuhe, Kleidung, Taschen und Accessoires an einem Ort zu finden.',
  'faq.q3': 'Ändern sich Preise und Links?',
  'faq.a3': 'Ja. Produktlinks, Preise, Verkäufer und Versandbedingungen können sich jederzeit ändern. Prüfe immer die aktuellen Informationen auf der Produktseite vor dem Kauf.',
  'faq.q4': 'Wohin führen die Kategorie-Buttons?',
  'faq.a4': 'Die Kategorie-Buttons und das Dropdown verlinken auf die Hauptwebsite, damit du dort die entsprechende Produktkategorie durchstöbern kannst.',

  'final.title': 'Bereit, das AllChinaBuy Spreadsheet zu entdecken?',
  'final.desc': 'Durchstöbere die neuesten Ressourcen, vergleiche Kategorien und gehe zur Hauptwebsite, wenn du bereit bist.',
  'final.cta': 'AllChinaBuy-Ressourcen entdecken',

  'footer.tagline': 'Eine unabhängige Informationsressource über das AllChinaBuy Spreadsheet.',
  'footer.disclaimer': 'Diese Website ist eine unabhängige Informationsressource und nicht die offizielle AllChinaBuy-Website. Produktverfügbarkeit, Preise, Links, Verkäufer, Versandoptionen und Angebote können sich ändern. Prüfe immer aktuelle Informationen vor dem Kauf.',
  'footer.resources': 'Ressourcen',
  'footer.categories': 'Kategorien',
  'footer.legal': 'Rechtliches',
  'footer.home': 'Startseite',
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.disclaimerLink': 'Haftungsausschluss',
  'footer.rights': 'Alle Rechte vorbehalten.',

  'lang.en': 'English',
  'lang.fr': 'Français',
  'lang.da': 'Dansk',
  'lang.de': 'Deutsch',

  'article.backHome': 'Zurück zur Startseite',
  'article.breadcrumbHome': 'Startseite',
  'article.breadcrumbGuides': 'Ratgeber',
  'article.updated': 'Zuletzt aktualisiert',
  'article.readingTime': 'Min. Lesezeit',
  'article.keyTakeaways': 'Wichtigste Erkenntnisse',
  'article.notFound': 'Artikel nicht gefunden',
};